import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

import { ErrorBoundary } from './components/ErrorBoundary.tsx'
import { reloadOnce } from './lib/chunkReload.ts'

// Cuando publicamos una version nueva, los nombres de los archivos de cada pantalla cambian.
// Si alguien tiene la app abierta desde antes del deploy y navega a una pantalla que su
// navegador todavia no habia cargado, Vite intenta pedir el archivo viejo (que ya no existe) y
// dispara este evento en vez de un error de React normal. Recargamos una sola vez para que la
// persona reciba la version nueva sin ver ninguna pantalla de error.
window.addEventListener('vite:preloadError', () => {
  reloadOnce();
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
)
